import * as mutationTypes from './mutationTypes'
import shortid from 'shortid'
import { initialState } from '@store/modules/billing'
import Vue from 'vue'

export default {
  'CLEAR_BILLING' (state) {
    state = initialState();
    // let initializedState = initialState()
    // Object.keys(initializedState).forEach(key => {
    //   Vue.set(state, key, initializedState[key])
    // })
  },

  CLEAR_SUBGROUP_DETAILS (state) {
    state.subGroupDetails = null;
    state.lobId = null;
  },

  [mutationTypes.CLEAR_BILLING_DETAILS_WITH_PORTAL_CONTEXT] (state) {
    let initializedState = initialState()
    Vue.set(state, 'subGroupDetails', initializedState['subGroupDetails'])
    Vue.set(state, 'currentPaymentMethod', initializedState['currentPaymentMethod'])
  },

  [mutationTypes.SET_PAYMENT_HISTORY] (state, paymentHistory = []) {
    state.paymentHistory = paymentHistory
    state.paymentHistoryLoading = false
  },

  [mutationTypes.BEGIN_LOADING_PAYMENT_HISTORY] (state) {
    state.paymentHistoryLoading = true
  },

  [mutationTypes.SET_PAYMENT_LOBS] (state, paymentLobs) {
    state.paymentLobs = paymentLobs
  },

  [mutationTypes.SET_PAYMENT_METHODS] (state, currentPaymentMethod) {
    if (currentPaymentMethod && currentPaymentMethod.status === 'noPaymentMethodFound') {
      state.currentPaymentMethod = {}
    } else {
      currentPaymentMethod.paymentMethodId = currentPaymentMethod.paymentMethodID
      state.currentPaymentMethod = currentPaymentMethod
    }
  },

  [mutationTypes.SET_LOADING_PAYMENT_METHODS] (state, loading) {
    state.paymentMethodsLoading = loading
  },

  [mutationTypes.SET_USER_PAYMENT_METHODS] (state, userPaymentMethods) {
    if (!Array.isArray(userPaymentMethods)) userPaymentMethods = []
    state.userPaymentMethods = userPaymentMethods
  },

  [mutationTypes.SET_LOADING_USER_PAYMENT_METHODS] (state, loading) {
    state.userPaymentMethodsLoading = loading
  },

  [mutationTypes.SET_INVOICES] (state, invoices = []) {
    console.log(`SET INVOICES`, invoices);
    let sortedInvoices = []
    if (Array.isArray(invoices)) {
      sortedInvoices = invoices
        .map(invoice => {
          invoice.key = shortid.generate()
          invoice.invoiceDate = invoice.invoiceType === 'EI1' ? invoice.billingMonth : invoice.invoiceDate
          return invoice
        })
        .sort(function(a, b) {
          return Number(new Date(b.invoiceDate)) - Number(new Date(a.invoiceDate))
        })
    }

    state.invoices = sortedInvoices
    state.invoicesLoading = false
  },

  [mutationTypes.SET_FILTERED_INVOICES] (state, invoices = []) {
    state.filteredInvoices = invoices
  },

  [mutationTypes.BEGIN_LOADING_INVOICES] (state) {
    console.log(`BEGIN LOADING INVOICES`);
    state.invoicesLoading = true
    state.isBlocking = false
    state.isUnBlocking = false
  },

  [mutationTypes.BEGIN_BLOCKING_INVOICES] (state) {
    state.isUnBlocking = false
    state.isBlocking = true
  },

  [mutationTypes.BEGIN_UNBLOCKING_INVOICES] (state) {
    state.isBlocking = false
    state.isUnBlocking = true
  },

  [mutationTypes.BLOCK_INVOICES] (state, selectedInvoices = []) {
    let tempInvoices = [...state.invoices]
    for (let i in tempInvoices) {
      if (selectedInvoices.indexOf(tempInvoices[i]) > -1) {
        tempInvoices[i].block = true
      }
    }
    state.invoices = tempInvoices
    state.isBlocking = false
  },

  [mutationTypes.UNBLOCK_INVOICES] (state, selectedInvoices = []) {
    let tempInvoices = [...state.invoices]
    for (let i in tempInvoices) {
      if (selectedInvoices.indexOf(tempInvoices[i]) > -1) {
        tempInvoices[i].block = false
      }
    }
    state.invoices = tempInvoices
    state.isUnBlocking = false
  },

  [mutationTypes.TOGGLE_BLOCKED_STATE_OF_SINGLE_INVOICE] (state) {
    state.singleInvoice = Object.assign({}, state.singleInvoice, {
      block: !state.singleInvoice.block
    })
    state.isBlocking = false
    state.isUnBlocking = false
  },

  [mutationTypes.UNBLOCK_ALL_INVOICES] (state) {
    for (let i in state.invoices) {
      state.invoices[i].block = false
    }
    state.isUnBlocking = false
  },

  [mutationTypes.SET_LOADING_CYBERSOURCE_DETAILS] (state, cybersourceDetailsLoading) {
    state.cybersourceDetailsLoading = cybersourceDetailsLoading
  },

  [mutationTypes.SET_CYBERSOURCE_DETAILS] (state, cybersourceDetails) {
    state.cybersourceDetails = cybersourceDetails
    state.cybersourceDetailsLoading = false
  },

  [mutationTypes.SET_AUTO_PAY_DETAILS] (state, autoPayDetails) {
    state.autoPayDetails = autoPayDetails
  },

  [mutationTypes.SET_SINGLE_INVOICE] (state, invoice) {
    console.log(`SET SINGLE INVOICE`, invoice);
    invoice.invoiceDate = invoice.invoiceType === 'EI1' ? invoice.billingMonth : invoice.invoiceDate
    state.singleInvoice = invoice
    state.invoicesLoading = false
    state.invoiceDetailsError = false
  },

  [mutationTypes.SET_SINGLE_INVOICE_ERROR] (state, invoiceDetailsErrorMessage) {
    console.log(`SET SINGLE INVOICE ERROR`, invoiceDetailsErrorMessage);
    state.invoicesLoading = false
    state.invoiceDetailsError = true
    state.invoiceDetailsErrorMessage = invoiceDetailsErrorMessage
  },

  [mutationTypes.SET_MAKING_PAYMENT] (state, makingPayment) {
    state.makingPayment = makingPayment
  },

  [mutationTypes.CONFIRM_PAYMENT] (state, paymentDetails) {
    state.makingPayment = false
    state.payment = paymentDetails
  },

  [mutationTypes.SET_ONETIME_PAYMENT_VARIABLES] (state, onetimePaymentDetails) {
    state.makingPayment = false
    state.onetimePaymentDetails = onetimePaymentDetails
  },

  [ mutationTypes.SET_INVOICES_USER_MESSAGE ] (state, userMessage) {
    console.log(`SET INVOICES USER MESSAGE`, userMessage);
    state.invoicesUserMessage = userMessage
    state.invoices = []
    state.invoicesLoading = false
  },

  [ mutationTypes.SET_CONFIGURING_RECURRING_PAYMENTS ] (state, configuring) {
    state.configuringRecurringPayments = configuring
  },

  [ mutationTypes.SET_DELETING_PAYMENT_METHOD ] (state, deleting) {
    state.deletingPaymentMethod = deleting
  },

  [ mutationTypes.SET_DELETING_USER_PAYMENT_METHOD ] (state, deleting) {
    state.deletingUserPaymentMethod = deleting
  },

  [ mutationTypes.UPDATE_DEFAULT_USER_PAYMENT_METHOD_LOADING ] (state, loading) {
    state.updateDefaultPaymentMethodLoading = loading
  },

  [ mutationTypes.SET_SUBGROUP_DETAILS_LOADING ] (state, loading) {
    state.subGroupDetailsLoading = loading
  },

  [ mutationTypes.SET_SUBGROUP_DETAILS ] (state, subGroupDetailsResponse) {
    console.log(`SET SUBGROUP DETAILS`, subGroupDetailsResponse);
    // todo, their original response body was gnarly
    //  -- if they change it, we can probably remove this check
    if (subGroupDetailsResponse && subGroupDetailsResponse.groups) { 
      state.subGroupDetails = subGroupDetailsResponse.groups[0]; 
      if(subGroupDetailsResponse.groups[0].subGroups) {
        state.lobId = subGroupDetailsResponse.groups[0].subGroups[0].lobId;
      }
      else {
        state.lobId = null;
      }
    }
  },

  [ mutationTypes.SET_CASH_ON_ACCOUNTS_LOADING ] (state, cashOnAccountsLoading) {
    state.cashOnAccountsLoading = cashOnAccountsLoading
  },

  [ mutationTypes.SET_CASH_ON_ACCOUNTS ] (state, cashOnAccounts) {
    state.cashOnAccounts = cashOnAccounts
  },

  [ mutationTypes.SET_PAYMENT_HISTORY_CONFIGURATION_LOADING ] (state, loading) {
    state.paymentHistoryConfigurationLoading = loading
  },

  [ mutationTypes.SET_PAYMENT_HISTORY_ENABLED ] (state, enabled) {
    state.paymentHistoryEnabled = enabled
  },

  [mutationTypes.SET_INVOICE_PAYMENT_HISTORY] (state, invoicePaymentHistory = []) {
    let tempInvoicePaymentHistory = []
    tempInvoicePaymentHistory = invoicePaymentHistory.map(invoice => {
      invoice.invoiceDate = invoice.invoiceType === 'PRM' || invoice.invoiceType === 'EI1' ? invoice.billingMonth : invoice.invoiceDate
      return invoice
    })
    state.invoicePaymentHistory = tempInvoicePaymentHistory
    state.invoicePaymentHistoryUserMessage = ''
    state.invoicePaymentHistoryLoading = false
  },

  [mutationTypes.SET_INVOICE_PAYMENT_HISTORY_LOADING] (state, loading) {
    state.invoicePaymentHistoryLoading = loading
  },

  [mutationTypes.SET_INVOICE_PAYMENT_HISTORY_USER_MESSAGE](state, userMessage) {
    state.invoicePaymentHistoryUserMessage = userMessage
    state.invoicePaymentHistory = []
    state.invoicePaymentHistoryLoading = false
  }

}
